/**
 * @author liqiuqi
 * @date 2023 2023/3/7 18:08
 */
import { getServicePhone } from "@/utils/common";
import { OID_MAP } from "@/utils/constants/constants.track";
import { PRODUCT_MANUAL } from "@/utils/constants/constants.menu";
import { CDN } from "@/utils/constants/constants";

export const SIDEBAR_NAMESPACE = {
  ONLINE_CONSULT: "online-consult",
  HOT_LINE: "hot-line",
  APP: "APP",
  PRESALE_CONSULT: "presale-consult",
  SERVICE_ACCOUNT: "service-account",
  HELP_CENTER: "help-center",
  SALES_WECHAT: "sales-weChat",
};

export const SIDEBAR_ITEMS = () => {
  // 字典改function 是因为 getServicePhone()执行时机不对，会导致返回的电话错误
  return [
    /** 企微客服 **/
    {
      id: SIDEBAR_NAMESPACE.SALES_WECHAT,
      oid: null,
      img: `${CDN}/0qlmgw/img/gw2/toolbar/icon_shouqian_n.png`,
      img_on_hover: `${CDN}/0qlmgw/img/gw2/toolbar/icon_shouqian_s.png`,
      name: "企微客服",
      link: "",
      is_hover: false,
      has_bay: true,
      bay_data: `<img class="qrcode" style="margin:5px auto 0;width:117px;height:117px;" src="${CDN}/0qlmgw/img/gw2/toolbar/img_shouqianpcode.png" alt="" /><div class="tip" style=" color: #333;font-size: 12px;padding-top: 6px; " >扫码添加企微专属客服<br/>为您提供一对一服务</div>`,
      bay_oid: null,
    },
    {
      id: SIDEBAR_NAMESPACE.ONLINE_CONSULT,
      oid: null,
      img: `${CDN}/0qlmgw/img/gw2/toolbar/icon_wx_n.png`,
      img_on_hover: `${CDN}/0qlmgw/img/gw2/toolbar/icon_wx_s.png`,
      name: "在线咨询",
      link: "",
      is_hover: false,
      has_bay: true,
      bay_data: `<img class="qrcode"  src="${CDN}/0qlmgw/img/gw2/toolbar/qrcode_online_consult.png" alt="" /><div class="tip" style=" color: #888; fontSize:14px; fontWeight:normalt; " >微信扫码</div><div class="tip" style=" color: #888 ; fontSize:14px;fontWeight:normal; " >一对一在线答疑~</div>`,
      bay_oid: null,
    } /** 咨询热线 **/,
    {
      id: SIDEBAR_NAMESPACE.HOT_LINE,
      oid: null,
      img: `${CDN}/0qlmgw/img/gw2/toolbar/icon_mobile_n.png`,
      img_on_hover: `${CDN}/0qlmgw/img/gw2/toolbar/icon_mobile_s.png`,
      name: "咨询热线",
      link: "",
      is_hover: false,
      has_bay: true,
      bay_data: `<div class="tip" style=" color: #DF6250; fontSize: 18px; fontWeight:600; " >${getServicePhone()}</div><div class="tip" style=" color: #888 ; fontSize:16px;fontWeight:normal; " >欢迎来电咨询~</div>`,
      bay_oid: null,
    } /** APP **/,
    {
      id: SIDEBAR_NAMESPACE.APP,
      oid: null,
      img: `${CDN}/0qlmgw/img/gw2/toolbar/icon_app_n.png`,
      img_on_hover: `${CDN}/0qlmgw/img/gw2/toolbar/icon_app_s.png`,
      name: "APP",
      link: "",
      is_hover: false,
      has_bay: true,
      bay_data: `<img class="qrcode"  src="${CDN}/0qlmgw/img/gw2/toolbar/img_appcode.png" alt="" />`,
      bay_oid: null,
    } /** 售前咨询 **/,
    {
      id: SIDEBAR_NAMESPACE.PRESALE_CONSULT,
      oid: null,
      img: `${CDN}/0qlmgw/img/gw2/toolbar/icon_serve_n.png`,
      img_on_hover: `${CDN}/0qlmgw/img/gw2/toolbar/icon_serve_s.png`,
      name: "售前咨询",
      link: "http://customer.qianlima.com/sale_before",
      is_hover: false,
      has_bay: false,
      bay_data: null,
      bay_oid: null,
    } /** 服务号 **/,
    {
      id: SIDEBAR_NAMESPACE.SERVICE_ACCOUNT,
      oid: null,
      img: `${CDN}/0qlmgw/img/gw2/toolbar/icon_wx_n.png`,
      img_on_hover: `${CDN}/0qlmgw/img/gw2/toolbar/icon_wx_s.png`,
      name: "服务号",
      link: "",
      is_hover: false,
      has_bay: true,
      bay_data: `<img class="qrcode"  src="${CDN}/0qlmgw/img/gw2/toolbar/qrcode_wx.jpg" alt="" />`,
      bay_oid: null,
    } /** 帮助中心 **/,
    {
      id: SIDEBAR_NAMESPACE.HELP_CENTER,
      oid: OID_MAP.HELP_CENTER_ICON,
      img: `${CDN}/0cdn/common/file/helpCenter/images/icon_help_s.png`,
      img_on_hover: `${CDN}/0cdn/common/file/helpCenter/images/icon_help_n.png`,
      name: "帮助中心",
      link: PRODUCT_MANUAL,
      defaultLink: PRODUCT_MANUAL,
      is_hover: false,
      has_bay: false,
      bay_data: null,
      bay_oid: null,
    },
  ];
};

export const AUTO_BAY_NAMESPACE = {
  HELP_CENTER_BIDDING_INFO: "help-center-bidding-info",
  HELP_CENTER_CONSTR_PROJECT: "help-center-constr-project",
  HELP_CENTER_EXAMINE_PROJECT: "help-center-examine-project",
  HELP_CENTER_SUB_BIDDING_INFO: "help-center-sub-bidding-info",
  HELP_CENTER_SUB_CONSTR_PROJECT: "help-center-sub-constr-project",
  HELP_CENTER_SUB_EXAMINE_PROJECT: "help-center-sub-examine-project",
};

export const AUTO_BAY = [
  {
    id: SIDEBAR_NAMESPACE.HELP_CENTER,
    children: [
      // 找商机 标讯
      {
        id: AUTO_BAY_NAMESPACE.HELP_CENTER_BIDDING_INFO,
        oid: OID_MAP.HELP_CENTER_BIDDING_INFO,
        text: "如何快速高效地搜索招中标信息，快来点击看看吧~",
        img: `${CDN}/0cdn/common/file/helpCenter/images/bidding-info-tip.png`,
        href: PRODUCT_MANUAL + "?id=8",
      },
      // 找商机 拟建
      {
        id: AUTO_BAY_NAMESPACE.HELP_CENTER_CONSTR_PROJECT,
        oid: OID_MAP.HELP_CENTER_CONSTR_PROJECT,
        text: "如何快速高效地搜索拟在建项目信息，快来点击看看吧~",
        img: `${CDN}/0cdn/common/file/helpCenter/images/constr-project-tip.png`,
        href: PRODUCT_MANUAL + "?id=9",
      },
      // 找商机 审批
      {
        id: AUTO_BAY_NAMESPACE.HELP_CENTER_EXAMINE_PROJECT,
        oid: OID_MAP.HELP_CENTER_EXAMINE_PROJECT,
        text: "如何快速高效地搜索审批目信息，快来点击看看吧~",
        img: `${CDN}/0cdn/common/file/helpCenter/images/examine-project-tip.png`,
        href: PRODUCT_MANUAL + "?id=10",
      },
      // 订阅 标讯
      {
        id: AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_BIDDING_INFO,
        oid: OID_MAP.HELP_CENTER_SUB_BIDDING_INFO,
        text: "如何高效准确地使用招标采购订阅器，快来点击看看吧~",
        img: `${CDN}/0cdn/common/file/helpCenter/images/bidding-info-tip.png`,
        href: PRODUCT_MANUAL + "?id=13",
      },
      // 订阅 拟建
      {
        id: AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_CONSTR_PROJECT,
        oid: OID_MAP.HELP_CENTER_SUB_CONSTR_PROJECT,
        text: "如何高效准确地使用拟在建项目订阅器，快来点击看看吧~",
        img: `${CDN}/0cdn/common/file/helpCenter/images/constr-project-tip.png`,
        href: PRODUCT_MANUAL + "?id=14",
      },
      // 订阅 审批
      {
        id: AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_EXAMINE_PROJECT,
        oid: OID_MAP.HELP_CENTER_SUB_EXAMINE_PROJECT,
        text: "如何高效准确地使用审批项目订阅器，快来点击看看吧~",
        img: `${CDN}/0cdn/common/file/helpCenter/images/examine-project-tip.png`,
        href: PRODUCT_MANUAL + "?id=15",
      },
    ],
  },
];
